import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import DIMPCR from "../../assets/images/generico/FONDOPCR.png";
import DIMPCRMOBILE from "../../assets/images/generico/FONDOPCR_MOBILE.png";
import Loading from "../../components/Genericos/Loading/Loading";
import Modal from "../../components/Genericos/Modal/Modal";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import RegistroPcr from "../../components/PortalPCR/RegistroPcr/RegistroPcr";
import fechaTurnoFormat from "../../../global/utils/fechaTurnoFormat";
import { logoutAuth } from "../../../global/context/action/auth/login";
import { hideModal, showModal } from "../../context/Actions/modal/modal";
import { wsPostDniPortalPCR } from "../../context/Actions/paciente/portalPaciente";
import { wsGetFAQ } from "../../context/Actions/preguntasFrecuentes/preguntasFrecuentes";
import { logoutRegistro } from "../../context/Actions/registro/logoutRegistro";
import { setListError } from "../../context/Actions/registro/registro";
import { showToaster } from "../../../global/context/action/toaster/toaster";
import { wsGetLaboTurnos } from "../../context/Actions/turnos/laboTurnos";
import { editaTurnosDisponibles } from "../../context/Actions/turnos/turnosDisponibles";
import { PortalContext } from "../../context/Provider";
import {
  regexEmail,
  regexNombre,
  regexNumero,
} from "../../../global/utils/expresionesRegulares";
import "./PortalPCR.css";
import VerMasIcon from "../../assets/images/generico/VerMasIcon";
import { GlobalContext } from "../../../global/context/Provider";
import InputV1 from "../../components/Genericos/InputV1/InputV1";

const PortalPCR = () => {
  const {
    modalState,
    modalDispatch,
    portalExteriorDispatch,
    preguntasFrecuentesState,
    preguntasFrecuentesDispatch,
    portalExteriorState,
    laboTurnosDispatch,
    turnosDisponiblesState,
    laboTurnosState,
    turnosDisponiblesDispatch,
    registroState,
    registroDispatch,
  } = useContext(PortalContext);

  // Cambio de contexto
  const { authState, authDispatch, toasterDispatch, toasterState } = useContext(GlobalContext);

  const history = useHistory();
  const [flgRegistro, setFlgRegistro] = useState(false);
  const [auxDni, setAuxDni] = useState(0);
  const campos = ["nombre", "nro_documento", "email", "domicilio"];
  const [registroDto, setregistroDto] = useState({
    aceptaAlertaWapp: false,
    bloqueado: false,
    cambiarClaveWeb: false,
    cumpleAnios: false,
    domicilio: "",
    email: null,
    esLoginPcr: false,
    expiradaClaveWeb: false,
    extranjero: false,
    idlocalidad: 0,
    nombre: "",
    nro_documento: 0,
    operador: "",
    partTemporal: false,
    pendAutParentesco: false,
    telmovilverificado: false,
    vctoken: false,
  });

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const showModalPreguntas = () => {
    showModal(
      "PortalPCR/ModalPortal/ModalPreguntas",
      {
        titulo: "Información sobre test COVID-19 (RT-PCR)",
        preguntasFrecuentes: preguntasFrecuentesState.preguntasFrecuentes.data,
        dissmiss: dissmiss,
      },
      [],
      "centro"
    )(modalDispatch);
  };

  const onChangeRegistro = (e) => {
    if (e !== undefined) {
      let errx = Object.assign({}, registroState.registro.listError);
      const name = e.target.name;
      switch (name) {
        case "nombre":
          errx.nombre = checkError(e.target.value);
          break;
        case "domicilio":
          errx.domicilio = isEmptyError(e.target.value);
          break;
        case "email":
          errx.email = isErrorEmail(e.target.value);
          break;
        default:
          errx.nro_documento = checkNumeroError(e.target.value);
      }
      setListError(errx)(registroDispatch);

      if (e.target.name === "extranjero") {
        setregistroDto({
          ...registroDto,
          [e.target.name]: e.target.checked,
          nro_documento: e.target.checked ? -1 : auxDni.nro_documento,
        });
      } else {
        setregistroDto({
          ...registroDto,
          [e.target.name]: e.target.value,
        });
        if (e.target.name === "nro_documento") {
          setAuxDni({ ...auxDni, [e.target.name]: e.target.value });
        }
      }
    }
  };
  const onChangeLocalidad = (e) => {
    if (e !== undefined) {
      if (e === "") {
        setregistroDto({
          ...registroDto,
          idlocalidad: 0,
        });
      } else {
        setregistroDto({
          ...registroDto,
          idlocalidad: e.id,
        });
      }
    }
  };

  const volver = () => {
    setregistroDto({ ...registroDto, extranjero: false });
    setFlgRegistro(false);
    logoutRegistro()(registroDispatch);
    if (registroDto.extranjero && registroDto.nro_documento === -1) {
      setregistroDto({ ...registroDto, nro_documento: auxDni.nro_documento });
    }
  };

  const onKeyPress = (e) => {
    if (!regexNumero.test(e.key)) {
      e.preventDefault();
    }
    if (e.key === "Enter") {
      verificarDni();
    }
  };

  useEffect(() => {
    wsGetFAQ()(preguntasFrecuentesDispatch);
    //logout para evitar loop de inicio.
    logoutAuth()(authDispatch);
  }, []);

  useEffect(() => {
    if (
      portalExteriorState.portalExterior.error !== null &&
      portalExteriorState.portalExterior.error !== false
    ) {
      setFlgRegistro(true);
    }
  }, [portalExteriorState.portalExterior.error]);

  useEffect(() => {
    if (portalExteriorState.portalExterior.data !== null) {
      const idGrupo = 3;
      wsGetLaboTurnos(fechaTurnoFormat(), -1, -1, idGrupo)(laboTurnosDispatch);
    }
  }, [portalExteriorState.portalExterior.data]);

  useEffect(() => {
    if (
      laboTurnosState.laboTurnos.data !== null &&
      laboTurnosState.laboTurnos.data !== undefined &&
      laboTurnosState.laboTurnos.data !== ""
    ) {
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        turnos: laboTurnosState.laboTurnos.data.data,
        grupoMedico: null,
        particular: null,
        idEstudio: null,
        descEstudio: null,
        descEspecialidad: null,
        fechaBusqueda: laboTurnosState.laboTurnos.data.fechaBusqueda,
        dtoBusqueda: null,
      })(turnosDisponiblesDispatch);
      history.push("/turnosdisponiblespcr");
    }
  }, [laboTurnosState.laboTurnos.data]);

  const checkError = (dato) => {
    if (regexNombre.test(dato)) {
      return false;
    }
    if (dato === "" || dato === 0 || dato === -1) {
      return true;
    }
  };
  const checkNumeroError = (dato) => {
    if (dato === "" || dato === 0 || dato === -1 || dato === undefined) {
      return true;
    } else if (regexNumero.test(dato)) {
      return false;
    }
  };

  const isErrorEmail = (email) => {
    if (!regexEmail.test(email)) {
      return true;
    }
    if (email === "") {
      return true;
    }
    return false;
  };

  const isEmptyError = (empty) => {
    if (empty === "") {
      return true;
    }
    return false;
  };

  const verificarDni = () => {
    let errx = Object.assign({}, registroState.registro.listError);
    if (flgRegistro && !registroDto.extranjero) {
      errx.nro_documento = checkNumeroError(registroDto.nro_documento);
      errx.nombre = checkError(registroDto.nombre);
      errx.email = isErrorEmail(registroDto.email);
      errx.domicilio = isEmptyError(registroDto.domicilio);
    } else if (!registroDto.extranjero) {
      errx.nro_documento = checkNumeroError(registroDto.nro_documento);
    } else {
      errx.nombre = checkError(registroDto.nombre);
      errx.email = isErrorEmail(registroDto.email);
      errx.domicilio = isEmptyError(registroDto.domicilio);
    }

    setListError(errx)(registroDispatch);
    let flgError = false;
    campos.forEach((item) => {
      if (errx[item]) flgError = true;
    });
    if (flgError) {
      showToaster(
        {
          texto:
            "Por favor, ingresá todos los campos requeridos en el formulario.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    } else {
      wsPostDniPortalPCR(registroDto)(portalExteriorDispatch);
    }
  };

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}
      <Loading
        dataLoading={portalExteriorState.portalExterior.loading}
        descripcion="Verificando..."
        color="c-white"
      />
      <div className="ptur-portalExterior-caja">
        <div className="ptur-portalExterior-boxImagenes">
          <img
            className="ptur-portalExterior-imagenFondo"
            src={DIMPCR}
            alt="fondo logo"
          ></img>
          <img
            className="ptur-portalExterior-imagenFondoMobile"
            src={DIMPCRMOBILE}
            alt="fondomobile logo"
          ></img>
        </div>
        <div className="ptur-portalExterior-rectanguloAzulGradient"></div>
        <div className="ptur-portalExterior-rectanguloAzul"></div>
        <div className="ptur-portalExterior-login">
          <img
            className="ptur-portalExterior-logo"
            src={process.env.PUBLIC_URL + "/assets/images/empresa/IsoLogo.png"}
            alt="logo"
          ></img>
          {registroDto.extranjero ||
            (!flgRegistro && (
              <div className="ptur-portalExterior-textos">
                <span className="rb24t c-white">
                  Hace un test COVID-19 (RT-PCR)
                </span>
                <span className="rb16l c-white ptur-portalExterior-texto2">
                  El test RT-PCR sirve para la detección COVID-19 para viajeros
                  o ante procedimientos médicos. El estudio no requiere
                  preparación previa.
                </span>
              </div>
            ))}
          <div className="ptur-portalExterior-formLogin">
            <div className="ptur-portalExterior-datosLogin">
              {!registroDto.extranjero && (
                <div className="ptur-portalExterior-inputDni">
                  <InputV1
                    className="ptur-modalReceta-textarea"
                    inputType="text"
                    name="nro_documento"
                    headerStr="Ingresá tu número de documento"
                    placeholderText="12345678"
                    errorStr="El documento es requerido"
                    onChange={onChangeRegistro}
                    maxLength="8"
                    isRequired={true}
                    onKeyPress={onKeyPress}
                    deshabilitaFormulario={flgRegistro}
                    value={auxDni.nro_documento ? auxDni.nro_documento : ""}
                    checkError={registroState.registro.listError.nro_documento}
                  />
                </div>
              )}
              <div className="ptur-portalExterior-extranjeroCheck">
                <input
                  className="ptur-portalExterior-checkbox"
                  type="checkbox"
                  name="extranjero"
                  onChange={onChangeRegistro}
                  id="checkExtranjero"
                  checked={registroDto.extranjero}
                  autoComplete="off"
                />
                <label htmlFor="checkExtranjero">Extranjero</label>
              </div>
              {(registroDto.extranjero || flgRegistro) && (
                <RegistroPcr
                  onChange={onChangeRegistro}
                  onChangeLocalidad={onChangeLocalidad}
                />
              )}

              <div className="ptur-portalExterior-botonesContainer">
                <div className="ptur-portalExterior-volverContainer">
                  {(registroDto.extranjero || flgRegistro) && (
                    <button
                      className="ptur-portalExterior-boton-volver rb16m c-latex30 bgc-white"
                      onClick={volver}
                    >
                      Volver
                    </button>
                  )}
                </div>
                <div>
                  <button
                    className={`ptur-portalExterior-boton-verificar rb18m c-white bgc-primary bgc-primary`}
                    onClick={() => verificarDni()}
                  >
                    {registroDto.extranjero || flgRegistro
                      ? "Registrar"
                      : "Verificar"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <button
              className="ptur-portalExterior-preguntas rb16m"
              onClick={showModalPreguntas}
            >
              Preguntas frecuentes de test COVID-19 (RT-PCR)
              <span>
                <VerMasIcon />
              </span>
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PortalPCR;
